import { LegalAgreementContent } from '../content.types';
import { dataFor } from '../data';
import { useLanguage } from './use-content';

export interface UseLegalAgreementContentResult {
  content?: LegalAgreementContent;
  isLoading: boolean;
}

export function useLegalAgreementContent(
  id?: string,
): UseLegalAgreementContentResult {
  const language = useLanguage();
  const map = dataFor('legalAgreements', language);
  const content = id ? map[id] : undefined;
  return { content, isLoading: false };
}
